module.exports = __webpack_public_path__ + "b9442fc4d2bf2ea5cb48a2226c657737.svg";